var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import ProductCategoryTabs, { EChangedComponent, } from "@frameworks/salesjourney/components/Generic/ProductCategoryTabs/ProductCategoryTabs";
import mutualFundDi from "@mainDi/features/mutualFund/servicelocator";
import "@frameworks/salesjourney/stylesheets/components/Features/ActivityBook/RM_Orderbook/RM_Orderbook.scss";
import actions from "@redux/feature/Markets/NCD/actions/ProductBouquetActions";
import OrderBookActions from "@redux/feature/Markets/NCD/actions/OrderBookActions";
import { useLocation } from "react-router-dom";
import GenericToast from "@frameworks/shared-library/components/GenericToast";
import { ESubProductIds, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import useCalculateZoom from "@frameworks/web/utils/useCalculateZoom";
import ErrorOrComingSoon from "@frameworks/shared-library/components/Orderbook/common/ErrorOrComingSoon";
import ProductOrdersProvider from "./ProductOrdersContext";
import { allProductsMap, bucketMap, } from "../common/MFProductSubProductCollection";
import { checkIfOtcIsAccessible } from "@frameworks/salesjourney/utils/genericMethods";
import { EOrderBookOrderBy } from "@frameworks/NCD/Enum/OTC";
import moment from "moment";
export var EOrderbookTabKeys;
(function (EOrderbookTabKeys) {
    EOrderbookTabKeys["PRODUCT_ORDERS"] = "1";
    EOrderbookTabKeys["ACCOUNT_OPENING"] = "2";
})(EOrderbookTabKeys || (EOrderbookTabKeys = {}));
var defaultData = {
    dropDownList: [],
    tabsDataList: [],
    selectedDropdownObject: {
        label: "",
        value: "",
    },
    selectedTabEventKey: "",
    selectedParent: {
        label: "",
        value: "",
    },
};
export var leadRedirectionState = {
    orderId: "",
    orderDate: "",
    productCode: "",
    categoryCode: "",
};
var ProductOrders = function () {
    var location = useLocation();
    var params = new URLSearchParams(location.search);
    leadRedirectionState.orderId = params.get("orderId");
    leadRedirectionState.categoryCode = params.get("categoryCode");
    leadRedirectionState.productCode = params.get("productCode");
    leadRedirectionState.productType = Number(params.get("productType"));
    var cOrderBookActions = new OrderBookActions();
    var cActions = new actions();
    var zoom = useCalculateZoom();
    // *******************************************
    // *           useStates                     *
    // *******************************************
    var _a = __read(useState(false), 2), isDetailedViewEnabled = _a[0], setDetailedViewEnabled = _a[1];
    var searchParams = new URLSearchParams(location.search);
    var _b = __read(useState(true), 2), isOtcAccessible = _b[0], setIsOtcAccessible = _b[1];
    var _c = __read(useState({
        isShow: false,
        isError: false,
        msg: "",
    }), 2), toastDetails = _c[0], setToastDetails = _c[1];
    var _d = __read(React.useState(defaultData), 2), productCategoryData = _d[0], setProductCategoryData = _d[1];
    var _e = __read(React.useState(), 2), productCategoryAPIData = _e[0], setProductCategoryAPIData = _e[1];
    var _f = __read(React.useState(null), 2), productOrdersNotificationComponent = _f[0], setProductOrdersNotificationComponent = _f[1];
    // *******************************************
    // *           REFS                          *
    // *******************************************
    var cleaningFunctionsRef = React.useRef([]);
    // *******************************************
    // *           useSelectors                 *
    // *******************************************
    // NA
    // *******************************************
    // *           API FUNCTIONS                 *
    // *******************************************
    var getCategoryListings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var skipFilters, otcIsAccessible, requestCategory, dataFromAPI, localProductCategoryData, localDropdownList, localDropdownSelectedObj, localTabsList, selectedTabIndex, err_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 3, , 4]);
                    skipFilters = ["Popular"];
                    return [4 /*yield*/, checkIfOtcIsAccessible()];
                case 1:
                    otcIsAccessible = _d.sent();
                    requestCategory = [
                        ESubProductIds.Bonds,
                        ESubProductIds.UnlistedShares,
                        ESubProductIds.NCD,
                        ESubProductIds.StructuredProducts,
                    ];
                    return [4 /*yield*/, mutualFundDi.mutualFunds.getMFCategoryFilters({
                            removeCategoryCodes: !otcIsAccessible ? requestCategory : [],
                            skipFilters: skipFilters,
                        })];
                case 2:
                    dataFromAPI = _d.sent();
                    localProductCategoryData = __assign({}, productCategoryData);
                    setProductCategoryAPIData(dataFromAPI);
                    localDropdownList = __spreadArray([], __read(dataFromAPI.mfL1LevelData), false);
                    localDropdownSelectedObj = (_a = localDropdownList[0]) !== null && _a !== void 0 ? _a : undefined;
                    // TODO: This block has to be re-looked
                    if (leadRedirectionState.categoryCode === ESubProductIds.MutualFund) {
                        localDropdownSelectedObj = localDropdownList.find(function (item) { return item.productTypeId === leadRedirectionState.productType; });
                    }
                    localProductCategoryData.dropDownList = localDropdownList;
                    localProductCategoryData.selectedDropdownObject =
                        localDropdownSelectedObj;
                    localProductCategoryData.selectedParent = localDropdownSelectedObj;
                    localTabsList = handleSortAndAddMissingProducts(dataFromAPI.mfL2LevelData[localDropdownSelectedObj.value], localDropdownSelectedObj);
                    selectedTabIndex = localTabsList.findIndex(function (tab) { return tab.eventKey == searchParams.get("productCode"); });
                    localProductCategoryData.selectedTabEventKey =
                        ((_b = localTabsList[selectedTabIndex]) === null || _b === void 0 ? void 0 : _b.eventKey) || ((_c = localTabsList[0]) === null || _c === void 0 ? void 0 : _c.eventKey);
                    localProductCategoryData.tabsDataList = isOtcAccessible
                        ? localTabsList
                        : localTabsList === null || localTabsList === void 0 ? void 0 : localTabsList.filter(function (element) { return element.eventKey !== ESubProductIds.StructuredProducts; });
                    // localProductCategoryData.selectedTabEventKey = localTabsList?.length
                    //   ? localTabsList[0].eventKey
                    //   : "";
                    handleUpdateProductCategoryData(localProductCategoryData);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _d.sent();
                    console.log(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // *******************************************
    // *           GENERATOR FUNCTIONS           *
    // *******************************************
    var generateSelectBackArrowButton = function () {
        return (React.createElement("span", { onClick: handleBackOnClick },
            React.createElement("i", { className: "edel-icon-left-arrow txt_ultramarine-blue2 hand_cursor" })));
    };
    // *******************************************
    // *           HANDLER FUNCTIONS             *
    // *******************************************
    var handleSortAndAddMissingProducts = function (dataFromAPI, localDropdownSelectedObj) {
        if (localDropdownSelectedObj === void 0) { localDropdownSelectedObj = productCategoryData.selectedParent; }
        var localTabsList = dataFromAPI === null || dataFromAPI === void 0 ? void 0 : dataFromAPI.reduce(function (accumulator, currentItem) {
            var localBucketData = bucketMap.get(localDropdownSelectedObj.value);
            var objectInArr = localBucketData.find(function (item) { return item.value === currentItem.value; });
            if (objectInArr) {
                accumulator.push(__assign(__assign({}, objectInArr), { title: currentItem === null || currentItem === void 0 ? void 0 : currentItem.label }));
            }
            else {
                accumulator.push({
                    title: currentItem.label,
                    eventKey: currentItem.value,
                    tabContent: React.createElement(ErrorOrComingSoon, null),
                });
            }
            return accumulator;
        }, []);
        return localTabsList;
    };
    var handleSortAndAddMissingSubProducts = function (localDropdownSelectedObj) {
        var localDataFromAPI = productCategoryAPIData.mfL2LevelData[productCategoryData.selectedParent.value].find(function (item) { return item.value === localDropdownSelectedObj.value; }).mfL3LevelData;
        var localTabsList = localDataFromAPI === null || localDataFromAPI === void 0 ? void 0 : localDataFromAPI.reduce(function (accumulator, currentItem) {
            var localBucketData = allProductsMap.get(localDropdownSelectedObj.value);
            var objectInArr = localBucketData.find(function (item) { return item.eventKey === currentItem.eventKey; });
            if (objectInArr) {
                accumulator.push(__assign(__assign({}, objectInArr), { title: currentItem.title }));
            }
            else {
                accumulator.push({
                    title: currentItem.title,
                    eventKey: currentItem.eventKey,
                    tabContent: React.createElement(ErrorOrComingSoon, null),
                });
            }
            return accumulator;
        }, []);
        return localTabsList;
    };
    useEffect(function () {
        checkIfOtcIsAccessible()
            .then(function (value) {
            setIsOtcAccessible(value);
        })
            .catch(function (e) {
            console.error(e);
            setIsOtcAccessible(true);
        });
    }, []);
    var handleOnClickViewAll = function (productId, subProductId, prodSubCatData, dataFromAPI) {
        if (prodSubCatData === void 0) { prodSubCatData = productCategoryData; }
        if (dataFromAPI === void 0) { dataFromAPI = productCategoryAPIData; }
        var localProductCategoryData = __assign({}, prodSubCatData);
        if (!isDetailedViewEnabled) {
            setDetailedViewEnabled(true);
        }
        var localDropDownList = dataFromAPI === null || dataFromAPI === void 0 ? void 0 : dataFromAPI.mfL2LevelData[localProductCategoryData === null || localProductCategoryData === void 0 ? void 0 : localProductCategoryData.selectedParent.value];
        var localTabList = allProductsMap === null || allProductsMap === void 0 ? void 0 : allProductsMap.get(productId);
        localProductCategoryData.dropDownList = localDropDownList;
        localProductCategoryData.selectedDropdownObject = localDropDownList === null || localDropDownList === void 0 ? void 0 : localDropDownList.find(function (item) { return item.value === productId; });
        localProductCategoryData.tabsDataList = isOtcAccessible
            ? localTabList
            : localTabList === null || localTabList === void 0 ? void 0 : localTabList.filter(function (element) { return element.eventKey !== ESubProductIds.StructuredProducts; });
        localProductCategoryData.selectedTabEventKey = subProductId;
        handleUpdateProductCategoryData(localProductCategoryData);
    };
    var handleBackOnClick = function () {
        setDetailedViewEnabled(!isDetailedViewEnabled);
        var localProdSubProdData = __assign({}, productCategoryData);
        localProdSubProdData.dropDownList = __spreadArray([], __read(productCategoryAPIData.mfL1LevelData), false);
        var selectedProductId = localProdSubProdData.selectedDropdownObject.value;
        localProdSubProdData.selectedDropdownObject =
            localProdSubProdData.selectedParent;
        localProdSubProdData.tabsDataList = handleSortAndAddMissingProducts(productCategoryAPIData.mfL2LevelData[localProdSubProdData.selectedDropdownObject.value], localProdSubProdData.selectedDropdownObject);
        localProdSubProdData.selectedTabEventKey = selectedProductId;
        handleUpdateProductCategoryData(localProdSubProdData);
    };
    var resetvalue = function () {
        cActions.resetFilterValue();
        cOrderBookActions.updateSelectedRefundType({
            id: 0,
            name: "",
            refund_description: "",
        });
        cOrderBookActions.setOrderBookRequestPayload({
            page_index: 1,
            page_size: 10,
            orderby: EOrderBookOrderBy.TRXDATE,
            orderbydesc: true,
            from_date: moment().startOf("month").format("YYYY-MM-DD"),
            to_date: moment().endOf("month").format("YYYY-MM-DD"),
            category_code: 0,
        });
    };
    var handleSelectAndTabChangeCallback = function (selectedData, changedComponent
    // apiData: IMutualFundsMainCategoryEntitiy
    ) {
        switch (changedComponent) {
            case EChangedComponent.SELECT:
                {
                    var localSelectedData = selectedData;
                    handleUpdateProductCategoryData(handleUpdateSelectedProductData(localSelectedData));
                }
                break;
            case EChangedComponent.TAB:
                {
                    var localSelectedData = selectedData;
                    handleUpdateProductCategoryData(__assign(__assign({}, productCategoryData), { selectedTabEventKey: localSelectedData }));
                    if (localSelectedData == ESubProductIds.Bonds ||
                        localSelectedData == ESubProductIds.UnlistedShares ||
                        localSelectedData == ESubProductIds.NCD ||
                        localSelectedData == ESubProductIds.StructuredProducts) {
                        resetvalue();
                    }
                }
                break;
        }
    };
    var handleUpdateSelectedProductData = function (selectedData) {
        var _a;
        var localSelectProductData = __assign({}, productCategoryData);
        localSelectProductData.selectedDropdownObject = selectedData;
        localSelectProductData.tabsDataList = isDetailedViewEnabled
            ? handleSortAndAddMissingSubProducts(selectedData)
            : handleSortAndAddMissingProducts(productCategoryAPIData.mfL2LevelData[selectedData.value], selectedData);
        if (!isDetailedViewEnabled) {
            localSelectProductData.selectedParent = selectedData;
        }
        localSelectProductData.selectedTabEventKey = ((_a = localSelectProductData === null || localSelectProductData === void 0 ? void 0 : localSelectProductData.tabsDataList) === null || _a === void 0 ? void 0 : _a.length)
            ? localSelectProductData.tabsDataList[0].eventKey
            : "";
        return localSelectProductData;
    };
    var handleUpdateProductCategoryData = function (data) {
        setProductCategoryData(function () { return data; });
    };
    // *******************************************
    // *           MISCELLANEOUS Functions       *
    // *******************************************
    var handleAddCleaningFunction = function (func) {
        var _a;
        (_a = cleaningFunctionsRef.current).push.apply(_a, __spreadArray([], __read(func), false));
    };
    var handleExecuteCleaningFunctions = function () {
        var _a;
        // This function runs all the cleaning functions that are contained in the ref
        (_a = cleaningFunctionsRef === null || cleaningFunctionsRef === void 0 ? void 0 : cleaningFunctionsRef.current) === null || _a === void 0 ? void 0 : _a.forEach(function (func) { return func(); });
        // TODO: Need to handle the case duplicate functions are added to ref
    };
    // *******************************************
    // *           constants                     *
    // *******************************************
    // NA
    // *******************************************
    // *           useEffects                    *
    // *******************************************
    React.useEffect(function () {
        getCategoryListings();
        return function () {
            handleExecuteCleaningFunctions();
        };
    }, []);
    return (React.createElement(ProductOrdersProvider, { value: {
            viewAllClickCallback: handleOnClickViewAll,
            detailedViewEnabled: isDetailedViewEnabled,
            setToastDetails: setToastDetails,
            handleAddCleaningFunction: handleAddCleaningFunction,
            setProductOrdersNotificationComponent: setProductOrdersNotificationComponent,
            productCategoryData: productCategoryData,
            setProductCategoryData: setProductCategoryData,
        } },
        React.createElement("div", { className: "d-flex align-items-center bg-ghost-white2 tabs-container-acitivity-book position-relative", style: { zoom: zoom } },
            productOrdersNotificationComponent &&
                createPortal(productOrdersNotificationComponent, document.getElementById("orderbook-primary-portal-container")),
            React.createElement(ProductCategoryTabs, __assign({ dropDownList: productCategoryData.dropDownList, tabsDataList: productCategoryData.tabsDataList, selectedDropdownObject: productCategoryData.selectedDropdownObject, selectedTabEventKey: productCategoryData.selectedTabEventKey, selectAndTabChangeCallback: handleSelectAndTabChangeCallback }, (isDetailedViewEnabled && {
                backArrowButton: generateSelectBackArrowButton(),
            }))),
            React.createElement(GenericToast, { message: React.createElement("div", { className: "d-flex align-items-center gap-2" },
                    toastDetails.isError ? (React.createElement("span", { className: "edel-icon-red-cross rounded-circle" })) : (React.createElement("span", { className: "edel-icon-tick bg-lime-green rounded-circle" })),
                    React.createElement("span", null, toastDetails.msg)), showHeader: false, position: "bottom-center", showCloseButtonInBody: true, theme: "dark-slate-blue", show: toastDetails.isShow, setClose: function () {
                    setToastDetails({ isShow: false, isError: false, msg: "" });
                }, autohide: true, parentClassName: "product-bouquet-toast" }))));
};
export default ProductOrders;
